import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CardListItem',
  props: {
    borderColor: null,
    isOutlined: { type: Boolean, default: true },
    hasBorder: { type: Boolean, default: true }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})